import { render, staticRenderFns } from "./18zongheguanli.vue?vue&type=template&id=6abc9172&scoped=true&"
import script from "./18zongheguanli.vue?vue&type=script&lang=js&"
export * from "./18zongheguanli.vue?vue&type=script&lang=js&"
import style0 from "./18zongheguanli.vue?vue&type=style&index=0&id=6abc9172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc9172",
  null
  
)

export default component.exports